function createAccordions() {
  const divContainer = document.querySelector('#accordionContainer');
  const h2Tags = divContainer.querySelectorAll('h2');

  h2Tags.forEach((h2) => {
    const accordionCategory = document.createElement('div');
    accordionCategory.classList.add('accordion-category');

    const accordionCategoryTitle = document.createElement('h2');
    accordionCategoryTitle.classList.add('accordion-category-title');
    accordionCategoryTitle.textContent = h2.textContent;

    accordionCategory.appendChild(accordionCategoryTitle);

    let nextElement = h2.nextElementSibling;
    while (nextElement && nextElement.tagName !== 'H2') {
      if (nextElement.tagName === 'H3') {
        const accordionWrapper = document.createElement('div');
        accordionWrapper.classList.add('accordion');

        const accordionTitle = document.createElement('button');
        accordionTitle.classList.add('accordion-title');
        accordionTitle.textContent = nextElement.textContent;

        const accordionContent = document.createElement('div');
        accordionContent.classList.add('accordion-content');

        let subNextElement = nextElement.nextElementSibling;
        while (subNextElement && subNextElement.tagName !== 'H3' && subNextElement.tagName !== 'H2') {
          const cloneElement = subNextElement.cloneNode(true);
          accordionContent.appendChild(cloneElement);
          subNextElement.remove();
          subNextElement = nextElement.nextElementSibling;
        }

        accordionWrapper.appendChild(accordionTitle);
        accordionWrapper.appendChild(accordionContent);

        accordionCategory.appendChild(accordionWrapper);
      }

      nextElement.remove();
      nextElement = h2.nextElementSibling;
    }

    h2.replaceWith(accordionCategory);
  });

  const accordionTitles = divContainer.querySelectorAll('.accordion-title');
  accordionTitles.forEach((title) => {
    title.addEventListener('click', () => {
      title.classList.toggle('active');
      const accordionContent = title.nextElementSibling;
      accordionContent.style.display = accordionContent.style.display === 'block' ? 'none' : 'block';
    });
  });
}
  
createAccordions();